<template>
  <section>
    <div class="beta-bg">
      <img :src="openStatusImage">
      <div class="white-point" @click="goPage()"></div>
    </div>
  </section>
</template>
<script>
export default {
  data: () => ({
    openStatusImage: ''
  }),
  async mounted () {
    this.$router.replace('/ssoLogin');
  },
  methods: {
    goPage () {
      this.$router.replace('/betaLogin');
    }
  }
};
</script>
<style scoped>
.beta-bg {
  width: 100%;
  height: 100vh;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.white-point {
  position: fixed;
  top: 0;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Index.vue